import React from 'react';
import TextWinds from '../../../components/common/TextWinds';
import { studentBadgeType } from '../../../constants/types/student-type';
import dayjs from 'dayjs';
interface StudentBadgeItemProps {
  badge: studentBadgeType;
}
const StudentBadgeItem = ({ badge }: StudentBadgeItemProps) => {
  const checkBadge = badge.achieveDate != null;
  return (
    <div
      className="flex flex-col items-center"
      // onClick={() => openCertification()}
    >
      <img
        src={badge.imagePath}
        className={`w-[120px] ${checkBadge ? '' : 'grayscale filter'}`}
      />
      <TextWinds type={'title_h3'} children={badge.name} />
      <TextWinds
        type={'caption1'}
        //children={new Date(badge.achieveDate).toLocaleDateString()}
      >
        {checkBadge ? dayjs(badge.achieveDate).format('YYYY-MM-DD') : ''}
      </TextWinds>
    </div>
  );
};

export default StudentBadgeItem;
